import React from "react";
import TablePagination from "../../common/components/Pagination";

const PaginationBlock = ({ resultCount, rowsPerPage, currentPage, onPageChange, onRowsPerPageChange }) => {
  const numberOfPages = Math.ceil(resultCount / rowsPerPage);
  return (
    <TablePagination
      numberOfPages={numberOfPages}
      currentPage={currentPage}
      rowsPerPage={rowsPerPage}
      onPageChange={(e, newPage) => onPageChange(newPage)}
      onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
    />
  );
};

export default PaginationBlock;
